import axios from 'axios';
const API_URL = "https://configuracion.siatigroup.com/api/";
export const api = axios.create({
    baseURL: API_URL,    
});
export default api;